import mailcheck from 'mailcheck';

mailcheck.defaultTopLevelDomains.push('me');
mailcheck.defaultDomains.push('hey.com');

export { mailcheck };

type MailcheckSuggestion = {
  full: string;
  address: string;
  domain: string;
};

/**
 * Check email spelling and suggest corrections.
 *
 * @param email - Email address to check
 * @param onSuggestion - Callback when a spelling correction is suggested
 * @param onValid - Callback when email domain is valid (no suggestion)
 * @returns Promise that resolves to true if valid, false if suggestion made
 */
export const checkEmailSpelling = (
  email: string,
  onSuggestion: (suggestion: MailcheckSuggestion) => void,
  onValid: () => void,
): Promise<boolean> => {
  return new Promise<boolean>((resolve) => {
    mailcheck.run({
      email,
      suggested: (suggestion: MailcheckSuggestion) => {
        onSuggestion(suggestion);
        resolve(false);
      },
      empty: () => {
        onValid();
        resolve(true);
      },
    });
  });
};
